import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const EducationListItem = (props) => {
  const { item } = props || {};
  const { t } = useTranslation();

  return (
    <div className="education-list-main-item">
      <Link to={`/education/${item?.id}`}>
        <div className="education-main-item-image">
          <img src={item?.image} className="img-fluid" />
        </div>
        <div className="education-main-item-content">
          <div className="education-main-item-center-text">
            <div className="education-main-item-content-title">
              {item?.name}
            </div>
            <div className="education-main-item-content-description">
              <div className="education-main-item-content-time">
                <img src="/images/clock-icon.png" className="img-fluid" />{" "}
                {item?.duration}
              </div>
              <div className="education-main-item-content-points">
                <img src="/images/star-icon.png" className="img-fluid" />{" "}
                {item?.points} {t("education.points")}
              </div>
            </div>
          </div>
          <div className="education-main-item-content-button">
            <div className="education-main-item-content-button-item">
              {t("education.education_list_item.view_details")}
            </div>
          </div>
        </div>
        <div className="education-main-item-points"></div>
      </Link>
    </div>
  );
};

export default EducationListItem;
